import { render, staticRenderFns } from "./BulkSendDetails.vue?vue&type=template&id=216d8edc&scoped=true&lang=pug"
import script from "./BulkSendDetails.vue?vue&type=script&lang=js"
export * from "./BulkSendDetails.vue?vue&type=script&lang=js"
import style0 from "./BulkSendDetails.vue?vue&type=style&index=0&id=216d8edc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d8edc",
  null
  
)

export default component.exports